/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-escape */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';

import { ToastContainer, toast } from 'react-toastify'; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
import NumberFormat from 'react-number-format';
// import Email from 'react-email-autocomplete';

class JoinEdit extends Component {
  state = {
    mouse: 0,
    dupButtonNicnameSate: 'A',
    outShow: false,
    chkVal: 0,
    outStep: 0,
    isDupNicname: true,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    // const { loginId, history } = this.props;

    //if(loginId !== '' && loginId !== null && loginId !== undefined ) {
    //history.push('/')
    //}
    const ran = Math.random();
    const backNumber = Math.floor(ran * 3);
    if (this._isMounted) {
      this.setState({
        backNumber,
      });
    }

    this._getData();
    window.addEventListener('message', this.callbackCert);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
    window.removeEventListener('message', this.callbackCert);
  };
  callbackCert = async (e) => {
    //console.log(e)
    // const { history } = this.props;
    if (e.data[0] === undefined || e.data[0] === null || e.data[0] === '') {
    } else {
      const callbackPart = e.data[0].callbackPart;
      const intReturn = e.data[0].intReturn;
      ////console.log(callbackPart)
      ////console.log(intReturn)
      if (callbackPart === 'SNS') {
        if (intReturn === '0') {
          toast.warn('해당 SNS계정으로 가입이 되어있습니다.');
        } else if (intReturn === '-1') {
          const snsid = e.data[0].snsid;
          // const snsUsername = e.data[0].username;
          // const snsEmail = e.data[0].email;
          //const snsPhoto = e.data[0].photo;
          const snsGubun = e.data[0].gubun;

          //console.log(snsid, snsEmail, snsGubun)
          setTimeout(() => {
            //alert(0)
            this.setState({
              //userid: 'aaaaaaaaaaa',
              snsid: snsid,
              snsGubun: snsGubun,
              snsJoin: true,
            });
          }, 500);
          toast.success(
            '인증이 정상적으로 완료되었습니다. 회원정보 수정을 클릭하시면 SNS 로그인이 등록됩다.'
          );
        } else {
          toast.error('SNS 계정 정보를 전달 중 오류가 발생했습니다.');
        }
      }
    }
  };
  _getData = async () => {
    const { loginId, history, pkg } = this.props;

    if (
      loginId === null ||
      loginId === undefined ||
      loginId === '' ||
      pkg === null ||
      pkg === undefined ||
      pkg === ''
    ) {
      history.push('/login');
    } else {
      const result = await this._getDataApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        const joinData = result.data[0].listData;

        //console.log(joinData[0].pkg)
        if (intReturn === 0) {
          if (this._isMounted) {
            this.setState({
              userid: joinData[0].userid,
              username: joinData[0].username,
              //password: joinData[0].password,
              //password_re: joinData[0].password,
              email: joinData[0].email,
              mobile: joinData[0].mobile,
              nicName: joinData[0].nicName,
              snsGunun: joinData[0].gubun,
              snsid: joinData[0].SNSID,
              snsJoin: joinData[0].snsJoin,
              joinData,
            });
          }
        } else {
          history.push('/');
        }
      }
    }
  };

  _getDataApi = () => {
    const { apiUrl, loginId, pkg, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    //console.log(at)
    //joinEdit
    return axios
      .post(
        apiUrl + '/joinEdit_pkg',
        {
          params: {
            userid: loginId,
            pkg: pkg,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log(error)
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
        //alert('오류가 발생했습니다.')
      });
  };
  _refreshToken = async (gubun) => {
    const { history, apiUrl, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 0) {
        this._getData();
      } else if (gubun === 1) {
        this._onEdit();
      } else if (gubun === 2) {
        this._onOutSubmit();
      }
    } else {
      this._onLogout();
      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  _dupNicname = async () => {
    const { nicName, dupButtonNicnameSate } = this.state;
    let confirm = 'Y';
    const s_pattern = /[~!@\#$%^&*\()\-=+_'\;<>\/.\`:\"\\,\[\]?|{}]/gi;
    // const k_pattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/gi;

    //console.log(dupButtonNicnameSate)
    if (dupButtonNicnameSate === 'A' || dupButtonNicnameSate === 'C') {
      this.setState({
        //nicName: '',
        isDupNicname: false,
        dupButtonNicnameSate: 'B',
      });
    } else {
      if (nicName === null || nicName === undefined || nicName === '') {
        toast.warn('중복 체크할 닉네임을 입력해 주세요.');
        confirm = 'N';
        return;
      }
      if (nicName.search(/\s/) !== -1) {
        toast.warn('닉네임에 공백문자는 포함될 수 없습니다.');
        confirm = 'N';
        return;
      }
      if (s_pattern.test(nicName) === true) {
        toast.warn(
          '닉네임에 [`~!@#$%^&*|\\\'";:/?등 의 특수문자는 포함될 수 없습니다.'
        );
        confirm = 'N';
        return;
      }

      if (confirm === 'Y') {
        const result = await this._dupNicnameApi();
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          toast.success('중복확인! 사용가능한 닉네임입니다.');
          this.setState({
            isDupNicname: true,
            dupButtonNicnameSate: 'C',
          });
        } else {
          toast.error('이미 사용중인 닉네임입니다.');
          this.setState({
            isDupNicname: false,
            dupButtonNicnameSate: 'B',
          });
        }
      }
    }
  };

  _dupNicnameApi = () => {
    const { apiUrl } = this.props;
    const { nicName } = this.state;

    return axios
      .post(apiUrl + '/dupNicname', {
        params: {
          nicName: nicName,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log(error)
      });
  };
  _chkValue = (e) => {
    //console.log(e.target.checked)
    this.setState({
      [e.target.name]: e.target.checked,
    });
  };
  _onMouseOver = (index) => {
    this.setState({
      mouse: index,
    });
  };
  _onNaver = () => {
    const { apiUrl } = this.props;
    window.open(apiUrl + '/naver/auth', '', '');
  };
  _onKakao = () => {
    const { apiUrl } = this.props;
    window.open(apiUrl + '/kakao/auth', '', '');
  };
  _onFacebook = () => {
    const { apiUrl } = this.props;
    window.open(apiUrl + '/facebook/auth', '', '');
  };
  _onGoogle = () => {
    const { apiUrl } = this.props;
    window.open(apiUrl + '/google/auth', '', '');
  };
  _onTwitter = () => {
    const { apiUrl } = this.props;
    window.open(apiUrl + '/twitter/auth', '', '');
  };
  _onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  _onEdit = async () => {
    const { setPkg } = this.props;
    const {
      userid,
      nicName,
      password,
      password_re,
      mobile,
      email,
      isDupNicname,
    } = this.state;

    if (userid === '' || userid === null || userid === undefined) {
      toast.warn('아아디를 입력해 주세요.');
      return;
    }
    if (nicName === '' || nicName === null || nicName === undefined) {
      toast.warn('닉네임을 입력해 주세요.');
      return;
    }
    if (isDupNicname === false) {
      toast.warn('닉네임 중복을 확인해 주세요.');
      return;
    }
    /*
        if(password === '' || password === null || password === undefined ) {
            toast.warn('비밀번호를 입력해 주세요.');
            return;
        }
        if(password.length > 20 || password.lenght < 4) {
            toast.warn('비밀번호는 4 ~ 20자리 문자, 숫자로 입력해 주세요.');
            return;
        }
        */

    if (password !== password_re) {
      toast.warn('비밀번호가 일치하지 않습니다..');
      return;
    }
    if (/(\w)\1\1\1/.test(password)) {
      alert('비밀번호안에 같은 문자는 4번 이상 사용할 수 없습니다.');
    }
    if (mobile === '' || mobile === null || mobile === undefined) {
      toast.warn('휴대폰 번호를 입력해 주세요.');
      return;
    }
    if (!/01[01689]-[1-9]{1}[0-9]{2,3}-[0-9]{4}$/.test(mobile)) {
      alert('휴대폰 번호 양식이 아닙니다.');
    }
    if (email === '' || email === null || email === undefined) {
      toast.warn('이메일을 입력해 주세요.');
      return;
    }
    if (
      !/^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i.test(
        email
      )
    ) {
      toast.warn('이메일 양식이 아닙니다.');
      return;
    }

    const result = await this._onEditApi();
    if (result) {
      const intReturn = result.data[0].intReturn;
      const data = result.data[0].listData;

      if (intReturn === 0) {
        toast.success('회원정보가 정상적으로 변경되었습니다.');
        const pkg = data[0].pkg;
        setPkg(pkg);
        //setTimeout(()=>{
        //    this._getData()
        //}, 500)
      } else {
        toast.error('회원정보를 수정중 오류가 발생했습니다.');
      }
    }
  };
  _onEditApi = () => {
    const { loginId, apiUrl, pkg, history } = this.props;
    const { nicName, password, mobile, email, snsid, snsGubun } = this.state;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/joinEditPost_pkg',
        {
          params: {
            userid: loginId,
            nicName: nicName,
            password:
              password === null || password === undefined || password === ''
                ? ''
                : password,
            mobile: mobile,
            email: email,
            snsid: snsid,
            snsGubun: snsGubun,
            pkg: pkg,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(1);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  _onOutShow = () => {
    //const { history } = this.props;
    this.setState({
      outShow: true,
    });
  };

  _checkValue = (e) => {
    //alert(0)
    ////console.log(e.target.value)
    this.setState({
      chkVal: e.target.value,
    });
  };
  _onOutClose = () => {
    this.setState({
      outShow: false,
    });
  };
  _onOutSubmit = () => {
    const { chkVal } = this.state;
    this.setState({
      outStep: 1,
    });

    if (chkVal === 0 || chkVal === undefined || chkVal === null) {
      toast.warn(
        '탈퇴 사유를 선택해주시면 회원님의 의견을 수렴하여 좀 더 발전하는 애니플러스가 되도록 노력하겠습니다.'
      );

      setTimeout(() => {
        this.setState({
          outStep: 0,
        });
      }, 2000);

      return;
    } else {
      this.setState({
        outShow: false,
      });
      confirmAlert({
        title: '회원탈퇴',
        message:
          '그동안 애니플러스를 이용해 주셔서 대단히 감사드립니다!. 탈퇴한 정보는 복구할 수 없습니다. 정말로 탈퇴 하시겠습니까?',
        buttons: [
          {
            label: '탈퇴하기',
            onClick: async () => {
              const result = await this._onOutSubmitApi();
              if (result) {
                const intReturn = result.data[0].intReturn;

                if (intReturn === 0) {
                  setTimeout(() => {
                    this._onLogout();
                  }, 500);
                } else {
                  setTimeout(() => {
                    toast.error(
                      '탈티 처리중 오류가 발생했습니다. 다시 시도하시거나 관리자에게 문의해 주세요.'
                    );
                  }, 500);
                }
              }
            },
          },

          {
            label: '취소',
            onClick: () => {
              this.setState({ outStep: 0, chkVal: 0, outShow: true });
            },
          },
        ],
      });
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };

  _onOutSubmitApi = () => {
    const { apiUrl, loginId, history } = this.props;
    const { chkVal } = this.state;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/joinOut',
        {
          params: {
            userid: loginId,
            chkVal: chkVal,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(2);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }

    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onLogout = () => {
    const { setLoginId, setAuthId, history } = this.props;

    this.setCookie('account', '');
    this.setCookie('ad', '');
    this.setCookie('at', '');
    this.setCookie('rt', '');
    this.setCookie('ni', '');
    this.setCookie('ic', '');

    setLoginId('');
    setAuthId('');

    localStorage.removeItem('at');
    localStorage.removeItem('rt');

    toast.success('정상적으로 탈퇴처리 되었습니다.');

    history.push('/');
  };
  _onHome = () => {
    const { history } = this.props;
    history.push('/');
  };
  _onBack = () => {
    const { history } = this.props;
    history.goBack();
  };
  render() {
    const {
      joinData,
      userid,
      password,
      password_re,
      email,
      mobile,
      nicName,
      dupButtonNicnameSate,
      outShow,
      chkVal,
      outStep,
    } = this.state;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        {outShow ? (
          <div
            className="secession_pop"
            style={
              outStep === 1 ? { zIndex: 9999 } : { zIndex: 21000000000000000 }
            }
          >
            <div className="secession_pop_group">
              <div className="secession_pop_close" onClick={this._onOutClose}>
                닫기
              </div>
              <h1>회원님의 탈퇴를 도와드립니다.</h1>

              <p>
                애니플러스에서 제공해 드리는 서비스를 더 이상 원치 않으시는
                회원님은 언제든지 애니플러스를 탈퇴하실 수 있습니다.
                <br />
                단, 탈퇴처리를 하신 회원님은 일정기간동안 본인명의와 아이디로
                재가입하실 수 없으며, 탈퇴전 응모한 이벤트의 당첨대상에서
                제외됩니다.
                <br />
                자세한 안내는 이용약관을 참고해 주십시오.
                <br />
              </p>
              <p>
                더욱 더 발전하는 애니플러스가 되겠습니다.
                <br />
                그동안 저희 애니플러스를 이용해 주셔서 감사드립니다.
                <br />
              </p>
              <h2>탈퇴사유</h2>

              <div className="chek_box_padding">
                <div className="chek_group">
                  <input
                    name="checkbox_1"
                    id="checkbox_1"
                    type="checkbox"
                    value={'1'}
                    checked={chkVal === '1' ? true : false}
                    className="checkbox_img"
                    onChange={this._checkValue}
                  />
                  <label htmlFor="checkbox_1">부담스러운 광고 </label>
                </div>
                <div className="chek_group">
                  <input
                    name="checkbox_2"
                    id="checkbox_2"
                    type="checkbox"
                    value={'2'}
                    checked={chkVal === '2' ? true : false}
                    className="checkbox_img"
                    onChange={this._checkValue}
                  />
                  <label htmlFor="checkbox_2">늦은 동영상 업데이트 </label>
                </div>
                <div className="chek_group">
                  <input
                    name="checkbox_3"
                    id="checkbox_3"
                    type="checkbox"
                    value={'3'}
                    checked={chkVal === '3' ? true : false}
                    className="checkbox_img"
                    onChange={this._checkValue}
                  />
                  <label htmlFor="checkbox_3">스트리밍의 낮은품질 </label>
                </div>
                <div className="chek_group">
                  <input
                    name="checkbox_4"
                    id="checkbox_4"
                    type="checkbox"
                    value={'4'}
                    checked={chkVal === '4' ? true : false}
                    className="checkbox_img"
                    onChange={this._checkValue}
                  />
                  <label htmlFor="checkbox_4">불안정한 서비스 </label>
                </div>
                <div className="chek_group">
                  <input
                    name="checkbox_5"
                    id="checkbox_5"
                    type="checkbox"
                    value={'5'}
                    checked={chkVal === '5' ? true : false}
                    className="checkbox_img"
                    onChange={this._checkValue}
                  />
                  <label htmlFor="checkbox_5">잦은 광고 메일 </label>
                </div>
                <div className="chek_group">
                  <input
                    name="checkbox_6"
                    id="checkbox_6"
                    type="checkbox"
                    value={'6'}
                    checked={chkVal === '6' ? true : false}
                    className="checkbox_img"
                    onChange={this._checkValue}
                  />
                  <label htmlFor="checkbox_6">고객서비스 불만 </label>
                </div>
                <div className="chek_group">
                  <input
                    name="checkbox_7"
                    id="checkbox_7"
                    type="checkbox"
                    value={'7'}
                    checked={chkVal === '7' ? true : false}
                    className="checkbox_img"
                    onChange={this._checkValue}
                  />
                  <label htmlFor="checkbox_7">기타</label>
                </div>
              </div>
              <a style={{ cursor: 'pointer' }} onClick={this._onOutSubmit}>
                탈퇴하기
              </a>
            </div>
          </div>
        ) : (
          <div className="login_container">
            <div className="login_logo">
              <a style={{ cursor: 'pointer' }} onClick={this._onHome}>
                <img src={imgUrl + '/img/login_img/login_logo.png'} />
              </a>
            </div>
            <div className="join_btn">
              <a style={{ cursor: 'pointer' }} onClick={this._onBack}>
                뒤로가기
              </a>
            </div>
            {/* backNumber === 1 ? 
                        (<img src="/img/login_img/EVENT-open_img.png" className="open_img" style={{cursor: 'pointer'}} onClick={this._onGoEvent}/>) 
                        : 
                        (<img src="img/login_img/GARUPARTY-open_img.png" className="open_img" style={{cursor: 'pointer'}} onClick={this._onGoEvent}/>) 
                        */}
            {joinData ? (
              <div className="login_content width5">
                <div className="login_padding">
                  <h1>회원정보수정</h1>
                  <div style={{ height: 15 }}></div>
                  <ul className="radius2">
                    <li className="on">
                      <input
                        name=""
                        type="text"
                        className="common_input login_input"
                        value={userid}
                        readOnly
                      />
                    </li>
                    <li>
                      <input
                        name="nicName"
                        maxLength={15}
                        type="text"
                        className="common_input login_input"
                        readOnly={
                          dupButtonNicnameSate === 'A' ||
                          dupButtonNicnameSate === 'C'
                            ? true
                            : false
                        }
                        value={nicName}
                        placeholder="닉네임"
                        onChange={this._onChange}
                        onFocus={() => this._onMouseOver(1)}
                      />
                      <input
                        type="button"
                        value={
                          dupButtonNicnameSate === 'A'
                            ? '변경하기'
                            : dupButtonNicnameSate === 'C'
                            ? '수정하기'
                            : '중복확인'
                        }
                        className="common_input input_btn"
                        onClick={this._dupNicname}
                      />
                      {/*<input name="" type="text" className="common_input login_input" value={joinData[0].nicName}/><input type="button" value="중복확인" className="common_input input_btn"/>*/}
                    </li>
                    <li>
                      <div>
                        <input
                          name="password"
                          type="password"
                          className="common_input login_input"
                          value={password}
                          placeholder="비밀번호"
                          onChange={this._onChange}
                        />
                      </div>
                      <div>
                        <input
                          name="password_re"
                          type="password"
                          className="common_input login_input"
                          value={password_re}
                          placeholder="비밀번호확인"
                          onChange={this._onChange}
                        />
                      </div>
                      <div className="clear"></div>
                    </li>
                    <li>
                      <NumberFormat
                        name="mobile"
                        format="###-####-####"
                        value={mobile}
                        className="common_input login_input"
                        placeholder="-없이 숫자만 입력"
                        onChange={this._onChange}
                      />
                    </li>
                    <li>
                      <input
                        name="email"
                        type="text"
                        className="common_input login_input"
                        value={email}
                        onChange={this._onChange}
                        placeholder="이메일"
                      />{' '}
                    </li>
                  </ul>

                  <div style={{ height: 15 }}></div>
                  <div className="login_btn">
                    <a style={{ cursor: 'pointer' }} onClick={this._onEdit}>
                      수정하기
                    </a>
                  </div>
                  <div className="join_secession">
                    <a style={{ cursor: 'pointer' }} onClick={this._onOutShow}>
                      회원탈퇴
                    </a>
                  </div>

                  <div className="etc_login">
                    <h2>SNS 로그인 연결하기</h2>
                    <div>
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={this._onTwitter}
                      >
                        <img src="img/login_img/etc_login_01.png" />
                      </a>
                      {/* <a
                        style={{ cursor: 'pointer' }}
                        onClick={this._onFacebook}
                      >
                        <img src="img/login_img/etc_login_02.png" />
                      </a> */}
                      <a style={{ cursor: 'pointer' }} onClick={this._onGoogle}>
                        <img src="img/login_img/etc_login_03.png" />
                      </a>
                      <a style={{ cursor: 'pointer' }} onClick={this._onKakao}>
                        <img src="img/login_img/etc_login_04.png" />
                      </a>
                      <a style={{ cursor: 'pointer' }} onClick={this._onNaver}>
                        <img src="img/login_img/etc_login_05.png" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        )}

        <ToastContainer position="bottom-right" hideProgressBar />
      </Fragment>
    );
  }
}

export default shopContext(withRouter(JoinEdit));
